import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DealerConfigs } from './models/DealerConfigs';

@Injectable({
  providedIn: 'root'
})
export class DealerSettingService {
  private readonly http = inject(HttpClient);

  getDealerConfigs(dealerId: string): Observable<DealerConfigs> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getDealerConfigs.replace('{dealerId}', dealerId)}`;
    return this.http.get<any>(url).pipe(map((response) => response.data));
  }
}
